module.exports = __webpack_public_path__ + "static/media/NutriGuide_user_manual_RO_LAT.214841ca.pdf";